import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "minus-open",
  "use": "minus-open-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"minus-open\"><g fill=\"none\" fill-rule=\"evenodd\"><path /><g fill=\"var(--bolt-theme-icon, currentColor)\"><path d=\"M12 21a9 9 0 110-18 9 9 0 010 18m0-20a11 11 0 100 22 11 11 0 000-22M16 11H8a1 1 0 00-1 1c0 .6.5 1 1 1h8c.6 0 1-.4 1-1s-.4-1-1-1\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol